module.exports = __webpack_public_path__ + "img/YT-UNF.fa6c3155.svg";